/* eslint-disable no-console */
type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_ENABLED = import.meta.env.DEV || import.meta.env.MODE === 'test';

class Logger {
  private getTimestamp(): string {
    return new Date().toLocaleTimeString();
  }

  private formatMessage(level: LogLevel, message: string): string {
    const timestamp = this.getTimestamp();
    return `[${timestamp}] [${level.toUpperCase()}] ${message}`;
  }

  debug(message: string, ...args: unknown[]): void {
    if (LOG_ENABLED) {
      console.debug(this.formatMessage('debug', message), ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (LOG_ENABLED) {
      console.info(this.formatMessage('info', message), ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (LOG_ENABLED) {
      console.warn(this.formatMessage('warn', message), ...args);
    }
  }

  error(message: string, ...args: unknown[]): void {
    if (LOG_ENABLED) {
      console.error(this.formatMessage('error', message), ...args);
    }
  }
}

export const log = new Logger();
